/**
 * 多窗口通信
 */
import storage from '@/scripts/tools/storage';

export default {
  sendMessage(key, value) {
    // 触发 storage 事件，使得其他窗口可以取到登录信息
    const _value = value || key;
    storage.add(key, _value);
    setTimeout(() => {
      storage.del(key);
    }, 100);
  },
  getMessage(cb) {
    window.addEventListener('storage', e => {
      let newValue = '';
      try {
        newValue = JSON.parse(e.newValue);
      } catch (error) {
        newValue = e.newValue;
      }
      if (!newValue) return;
      cb(e.key, newValue);
    });
  },
};
